import { defineMessages } from 'react-intl'

/** Trip Planner UI actions and labels — `docs/product-taxonomy.md` §10. */
const tripPlannerGlossaryMessages = defineMessages({
  addToTrip: {
    id: 'BR_KZw03BufNxuYb89An',
    defaultMessage: 'Add to trip',
    description: 'Primary CTA to add a hotel, tour, or offer item to the trip planner itinerary',
  },
  saveToTrip: {
    id: 'VTTsrzGbwvW6-qa4s13_',
    defaultMessage: 'Save to trip',
    description: 'CTA to save a bookmark, room, or search into the customer trip planner',
  },
  removeFromTrip: {
    defaultMessage: 'Remove from trip',
    id: 'eCiiKHhCQp6RhnWmqEDH',
    description: 'Action to remove a saved or planned item from the current trip itinerary',
  },
  buildMyTrip: {
    id: 'pNkA5wRSo3yds4TDb79B',
    defaultMessage: 'Build my trip',
    description: 'CTA to open or continue building a multi-stop trip from My Escapes or offer flows',
  },
  createNewTrip: {
    id: '6sC1SRhnrQSVaxyO1KmY',
    defaultMessage: 'Create new trip',
    description: 'Action to start a new empty trip in trip planner chat, modals, or list views',
  },
  createTrip: {
    defaultMessage: 'Create trip',
    id: 'KNvG6QrCCzxX0sz-0Dwy',
    description: 'Shorter CTA to create a trip when space is limited in mobile headers and toolbars',
  },
  deleteTrip: {
    id: 'AWPPJhbrAK3GM9ED9eXg',
    defaultMessage: 'Delete trip',
    description: 'Action to delete an existing trip from the trip list or confirmation modal',
  },
  leaveTrip: {
    id: 'ABSmIN45uJvaAgQ1AuP1',
    defaultMessage: 'Leave trip',
    description: 'Action for a collaborator to leave a shared trip from share settings or menus',
  },
  viewTripPlan: {
    id: 'DaWuzN5uZ8KhtII7opV_',
    defaultMessage: 'View trip plan',
    description: 'Link to open the saved trip itinerary or summary from home, chat, and carousels',
  },
  changeTripImage: {
    defaultMessage: 'Change trip image',
    id: 'L7YRrlhUeFwvkYFcUw8I',
    description: 'Action to change the cover image for a trip in trip settings or edit flows',
  },
  nameYourNewTrip: {
    defaultMessage: 'Name your new trip',
    id: 'Y9cGtZfJAheCyAD6mzlD',
    description: 'Modal or form heading when the customer must name a newly created trip',
  },
  tripItinerary: {
    defaultMessage: 'Trip itinerary',
    id: 'bggPj5o2_5C2ayK-JRUW',
    description: 'Heading for the ordered list of items and dates within a trip',
  },
  tripStarts: {
    defaultMessage: 'Trip starts',
    id: 'TsScHutgy_XaBvlKWDcX',
    description: 'Label before the first departure date in timeline and card layouts',
  },
  tripPlans: {
    defaultMessage: 'Trip plans',
    id: 'X3S2PMCdtRWUb8bXHnw-',
    description: 'Plural page or tab title when listing the customer’s saved trip plans',
  },
  trips: {
    defaultMessage: 'Trips',
    id: '0J4eTLz_ALqDXc6V-1hx',
    description: 'Short plural nav or tab label for the customer’s list of trip planner itineraries',
  },
  untitled: {
    id: '_7HK-d4iDxA3EYUeWpP8',
    defaultMessage: 'Untitled',
    description: 'Fallback title for an AI chat or classic trip without a name in Trip Planner lists, such as the side nav, chat search results, landing recent chats and offer-page chat history',
  },
  recentChats: {
    id: 'MrHUHNYD3PDROyKfidh7',
    defaultMessage: 'Recent chats',
    description: 'Section label above the list of recent chats on the trip planner chat landing page, side nav and menu drawer',
  },
  showLess: {
    id: 'VhExlPCDRKQzbmDLR3wP',
    defaultMessage: 'Show less',
    description: 'Link that collapses an expanded list back to its first few items in Trip Planner chat, such as recent chats or upcoming trips',
  },
})

export default tripPlannerGlossaryMessages
